/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React from "react";

import { css } from "@compiled/react";

import ModalDialog, { ModalTransition } from "@atlaskit/modal-dialog";

import SiteSelectorView from "./site-selector-view";

export type SiteSelectorModalProps = {
    readonly isOpen: boolean;

    readonly userName: string;
    readonly userEmail: string;
    readonly avatarSrc?: string;

    readonly sites: string[];

    readonly header?: React.ReactNode;

    readonly onNewSiteSelected: () => void;
    readonly onSiteSelected: (site: string) => void;
    readonly onSiteChanged?: () => void;
    readonly onSwitchAccountClick: () => void;
    readonly onModalClose?: () => void;
};

const SiteSelectorModal = ({
    isOpen,
    userName,
    userEmail,
    avatarSrc,
    sites,
    header,
    onNewSiteSelected,
    onSiteSelected,
    onSwitchAccountClick,
    onSiteChanged,
    onModalClose
}: SiteSelectorModalProps) => {
    const onClose = () => {
        if (onModalClose) {
            onModalClose();
        }
    };

    const onChange = () => {
        if (onSiteChanged) {
            onSiteChanged();
        }
    };

    return (
        <ModalTransition>
            {isOpen && (
                <ModalDialog onClose={onClose}>
                    <div css={containerStyle}>
                        <SiteSelectorView
                            userName={userName}
                            userEmail={userEmail}
                            avatarSrc={avatarSrc}
                            sites={sites}
                            header={header}
                            onNewSiteSelected={onNewSiteSelected}
                            onSiteSelected={onSiteSelected}
                            onSwitchAccountClick={onSwitchAccountClick}
                            onCancelClick={onClose}
                            onSiteChanged={onChange}
                        />
                    </div>
                </ModalDialog>
            )}
        </ModalTransition>
    );
};

export default SiteSelectorModal;

const containerStyle = css({
    margin: "22px"
});
